<template>
  <div class="header">
    <div class="list-search">
      <div class="left">
        <p class="number">{{data.licenses}}</p>
        <p>开通数量</p>
      </div>
      <div class="right">
        <div>
          <p>{{data.dayLicenses}}</p>
          <p>今天</p>
        </div>
        <div>
          <p>{{data.weekLicenses}}</p>
          <p>本周</p>
        </div>
        <div>
          <p>{{data.monthLicenses}}</p>
          <p>本月</p>
        </div>
        <div>
          <p>{{data.quarterLicenses}}</p>
          <p>本季</p>
        </div>
        <div>
          <p>{{data.yearLicenses}}</p>
          <p>本年</p>
        </div>
      </div>
    </div>
    <div class="list-search">
      <div class="left">
        <p class="number">{{data.customers}}</p>
        <p>客户总数</p>
      </div>
      <div class="right">
        <div>
          <p>{{data.dayCustomers}}</p>
          <p>今天</p>
        </div>
        <div>
          <p>{{data.weekCustomers}}</p>
          <p>本周</p>
        </div>
        <div>
          <p>{{data.monthCustomers}}</p>
          <p>本月</p>
        </div>
        <div>
          <p>{{data.quarterCustomers}}</p>
          <p>本季</p>
        </div>
        <div>
          <p>{{data.yearCustomers}}</p>
          <p>本年</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('statis')
export default {
  data() {
    return {
      data:{}
    }
  },
  created(){
    this.getLicense()
  },
  methods:{
    ...mapActions(['getTotal']),
    async getLicense(){
      this.data = await this.getTotal()
    }
  }
}
</script>
